import { TextField } from '@mui/material';

interface TenantDomainFieldProps {
  value: string;
  error?: string;
  setValue: (value: string) => void;
}

function TenantDomainField({
  value,
  error,
  setValue,
}: TenantDomainFieldProps): React.JSX.Element {
  return (
    <TextField
      fullWidth
      required
      label='Tenant Domain'
      value={value}
      error={Boolean(error)}
      helperText={error}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default TenantDomainField;

